import { constant, fieldRef, op } from './astHelpers';

const compareOp = (operator) => String(operator || 'EQUAL').toUpperCase();

const evalLeafCondition = (cond) => {
  if (!cond) return constant(1);
  const left = cond.leftType === 'CONSTANT'
    ? constant(cond.leftValue)
    : fieldRef(cond.leftFieldCode || cond.fieldCode);
  const right = cond.rightType === 'FIELD'
    ? fieldRef(cond.rightFieldCode)
    : constant(cond.rightValue);
  return op(compareOp(cond.operator), [left, right]);
};

/**
 * Conditional: IF(condition, thenExpr, elseExpr)
 * conditionTree: { logic: 'AND'|'OR', conditions: [{ leftFieldCode, operator, rightValue }] }
 */
export const buildConditionalFormula = (cfg = {}) => {
  const tree = cfg.conditionTree;
  if (!tree || !Array.isArray(tree.conditions) || !tree.conditions.length) return null;

  const parts = tree.conditions.map(evalLeafCondition);
  const logic = String(tree.logic || 'AND').toUpperCase();
  const condition = parts.length === 1
    ? parts[0]
    : op(logic === 'OR' ? 'OR' : 'AND', parts);

  const thenExpr = cfg.thenFieldCode
    ? fieldRef(cfg.thenFieldCode)
    : (cfg.thenAst || (cfg.baseFieldCode ? fieldRef(cfg.baseFieldCode) : constant(cfg.thenValue ?? 0)));

  const elseExpr = cfg.elseFieldCode
    ? fieldRef(cfg.elseFieldCode)
    : constant(cfg.elseValue ?? 0);

  return {
    operator: 'IF',
    condition,
    then: thenExpr,
    else: elseExpr,
  };
};
